import React from "react";
import { useTranslation } from "react-i18next";
import {
  Organization,
  Partners,
  Diamond,
  Magnet,
  People,
  Contracts
} from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import { Button } from "@/components/ui/button";
import { GlobalSearchFilterTypes } from "../types";

interface EntityFiltersProps {
  activeFilter: GlobalSearchFilterTypes;
  onFilterChange: (filter: GlobalSearchFilterTypes) => void;
  hiddenFilters?: GlobalSearchFilterTypes[];
}

export const EntityFilters: React.FC<EntityFiltersProps> = ({
  activeFilter,
  onFilterChange,
  hiddenFilters = []
}) => {
  const { t } = useTranslation();
  const filterOptions = [
    {
      key: GlobalSearchFilterTypes.ALL,
      labelKey: "globalSearch.entityFilters.all",
      icon: null
    },
    {
      key: GlobalSearchFilterTypes.COMPANIES,
      labelKey: "globalSearch.entityFilters.companies",
      icon: Organization
    },
    {
      key: GlobalSearchFilterTypes.PARTNERS,
      labelKey: "globalSearch.entityFilters.partners",
      icon: Partners
    },
    {
      key: GlobalSearchFilterTypes.DEALS,
      labelKey: "globalSearch.entityFilters.deals",
      icon: Diamond
    },
    {
      key: GlobalSearchFilterTypes.LEADS,
      labelKey: "globalSearch.entityFilters.leads",
      icon: Magnet
    },
    {
      key: GlobalSearchFilterTypes.PEOPLE,
      labelKey: "globalSearch.entityFilters.people",
      icon: People
    },
    {
      key: GlobalSearchFilterTypes.CONTRACTS,
      labelKey: "globalSearch.entityFilters.contracts",
      icon: Contracts
    }
  ].filter((option) => !hiddenFilters.includes(option.key));

  return (
    <div
      data-test="global-search-entity-filters"
      className="flex items-center space-x-2 overflow-x-auto"
    >
      {filterOptions.map((option, index) => {
        const isActive = activeFilter === option.key;
        const Icon = option.icon;
        const label = t(option.labelKey);

        return (
          <Button
            key={option.key}
            data-test={`global-search-filter-${option.key}`}
            variant="filter"
            selected={isActive}
            onClick={() => onFilterChange(option.key)}
            aria-pressed={isActive}
            title={t("globalSearch.entityFilters.filterBy", {
              label,
              index: index + 1
            })}
          >
            {Icon && (
              <IconContainer size="sm">
                <Icon />
              </IconContainer>
            )}
            <span>{label}</span>
          </Button>
        );
      })}
    </div>
  );
};
